import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { Box, useMediaQuery } from "@mui/material"
import BaseImage from "../BaseImage"

import { setShowPreLoadingScreen } from "../../store"

import LoadingScreenDesktop from '../../assets/images/home/screen-pre-loading-desktop.svg'
import LoadingScreenMobile from '../../assets/images/home/screen-pre-loading-mobile.svg'

const AppPreLoadingScreen = () => {
  const dispatch = useDispatch()
  const md = useMediaQuery((theme) => theme.breakpoints.down('md'));
  
  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(setShowPreLoadingScreen(false))
    }, 1000)
    return () => clearInterval(interval)
  }, [dispatch])

  return (
    <Box
      sx={{
        width: '100%',
        height: '100vh',
        bgcolor: 'white',
        backgroundSize: 'cover',
        overflow: 'hidden'
      }}
    >
      <BaseImage
        sx={{
          padding: { xs: 0, md: '8px' },
          width: '100%',
          height: '100vh',
        }}
        sximage={{
          borderRadius: md ? 0 : '10px',
          objectFit: 'cover'
        }}
        src={md ? LoadingScreenMobile : LoadingScreenDesktop}
        alt='pre-loading-screen' 
      />
    </Box>
  )
}

export default AppPreLoadingScreen